import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'booleanTransform'})
export class BooleanPipe implements PipeTransform {

    transform(value: any) {
        return value ? 'Oui' : 'Non';
    }

}